import { useService } from 'react-reservice';

import { signUpDemoService } from './service';

export const useSignUpDemo = () => useService(signUpDemoService, (context) => context);

export const useSignUpDemoDefaultDeposit = () => useService(signUpDemoService, (context) => context.defaultDeposit);
